import { render, staticRenderFns } from "./SubmitForm.vue?vue&type=template&id=a705a05c&scoped=true"
import script from "./SubmitForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SubmitForm.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SubmitForm.vue?vue&type=style&index=0&id=a705a05c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a705a05c",
  null
  
)

export default component.exports